import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useTypedSelector } from '../../../../core-module/redux';
import { absenceClient } from '../../../../core-module/services/absence/AbsenceClient';
import { Confirmation } from '../../../../core-module/services/absence/types';
import { ReplacementOverviewComponent } from './ReplacementOverviewComponent';

const ReplacementOverviewContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [confirmations, setConfirmations] = useState<Confirmation[]>([]);

  const driverId = useTypedSelector((state) => state.auth.user.driver!.id);

  useEffect(() => {
    if (loading) {
      absenceClient
        .getConfirmations(driverId)
        .then((response) => setConfirmations(response.confirmations))
        .catch(() =>
          Swal({
            title: 'Helaas',
            html: 'Er is iets misgegaan bij het ophalen van afwezigheid',
            type: 'error',
            confirmButtonText: 'Ok'
          })
        )
        .finally(() => setLoading(false));
    }
  }, [loading, driverId]);

  const handleConfirm = (absencePeriodId: number, replacementId: number, accepted: boolean) => {
    absenceClient
      .confirmConfirmation(driverId, absencePeriodId, replacementId, { accepted })
      .then(() =>
        Swal({
          title: accepted ? 'Vervanging bevestigd' : 'Vervanging afgewezen',
          html: accepted
            ? 'De vervanging is succesvol bevestigd'
            : 'De vervanging is succesvol afgewezen',
          type: 'success',
          confirmButtonText: 'Ok'
        })
      )
      .catch((err) =>
        Swal({
          title: 'Er is iets misgegaan',
          html: err.message,
          type: 'error',
          confirmButtonText: 'Ok'
        })
      )
      .finally(() => setLoading(true));
  };

  return (
    <ReplacementOverviewComponent
      loading={loading}
      confirmations={confirmations}
      onConfirm={handleConfirm}
    />
  );
};

export { ReplacementOverviewContainer };
